import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GetAllCategories } from '../../redux/Slices/CategorySlice';

const UseAllCategory = () => {
  const limit = 12;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true)
  const [pageLoading, setPageLoading] = useState(true)
  const [SearchLoading, setSearchLoading] = useState(true)
  const [allCategories, setAllCategories] = useState()
  const [searchValue, setSearchValue] = useState("")
  const [pageCount, setPageCount] = useState()
  const { AllCategories } = useSelector((state) => state.CategoryReducer);

  // to get all Categories
  const getAllCategories = async () => {
    setLoading(true)
    await dispatch(GetAllCategories(`limit=${limit}`));
    setLoading(false)
  }

  // to run the get all categories data
  useEffect(() => {
    getAllCategories();
  }, []);


  // to handle the request response of get All Categories
  useEffect(() => {
    if (loading === false) {
      if (AllCategories && AllCategories.data) {
        setAllCategories(AllCategories.data)
        setPageCount(AllCategories.paginationResult.numberOfPages)
      }
    }
  }, [loading])

  // handle change search input value
  const handleChangeSearchValue = (e) => {
    setSearchValue(e.target.value)
  }

  // handle search by value input 
  const handleSearchValueFunction = async () => {
    setSearchLoading(true)
    await dispatch(GetAllCategories(`limit=${limit}&name=${searchValue}`))
    setSearchLoading(false)
  }

  // handle search value function response
  useEffect(() => {
    if (SearchLoading === false) {
      setAllCategories(AllCategories.data)
    }
  }, [SearchLoading])


  // to run get all categories function
  useEffect(() => {
    if (searchValue === "") {
      getAllCategories()
    } else {
      handleSearchValueFunction()
    }
  }, [searchValue])


  // to handle the pagination
  const onPress = async (page) => {
    setPageLoading(true)
    await dispatch(GetAllCategories(`limit=${limit}&page=${page}`));
    setPageLoading(false)
  }

  // handle on press pagination request rrsponse 
  useEffect(() => {
    if (pageLoading === false) {
      if (AllCategories && AllCategories.data) {
        setAllCategories(AllCategories.data)
      }
    }
  }, [pageLoading])


  return [searchValue, handleChangeSearchValue, allCategories, loading, pageCount, onPress]
}

export default UseAllCategory
